import { render, staticRenderFns } from "./editActivitiesType.vue?vue&type=template&id=1c5d9cd4"
import script from "./editActivitiesType.vue?vue&type=script&lang=js"
export * from "./editActivitiesType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports